/**
 * Component Registry for Astoria
 * 
 * Inherits from @vibesites-amc-preferred-theme/theme-preferred and allows property-specific overrides.
 */

import type { ComponentRegistry } from '@vibesites/runtime';
import { registry as parentRegistry } from '@vibesites-amc-preferred-theme/theme-preferred/registry';
import { AmenitiesList } from './components/AmenitiesList';
import { PropertyOverview } from './components/PropertyOverview';
import { ReviewsCallout } from './components/ReviewsCallout';

/**
 * Property-specific component overrides.
 */
const propertyOverrides: Partial<ComponentRegistry> = {
  AmenitiesList,
  PropertyOverview,
  ReviewsCallout,
};

/**
 * Final merged registry for this property.
 * Inherits all components from the parent theme, with property overrides.
 */
export const registry: ComponentRegistry = {
  ...parentRegistry,
  ...propertyOverrides,
};

export default registry;
